<!--
The 'Share Album' page.   ("Collateral" means the same thing as "album photo")
-->
<template>
  <div class="linked-album">
    <!-- :style="iframeZoomCss" -->
    <div class="institution__header">
      <img
        v-if="logoURL !== null"
        class="institution_logo"
        :src="`${logoURL}?w=400&h=140`"
      >
    </div>
    <div class="items-grid-container">
      <items-grid
        linked
        :items="elements"
        :title="title"
        :can-upload="false"
        :can-hover="canHover()"
        :current-folder="currentFolder"
        :count="count"
        :loading="loading"
        is-shared
        @search="onSearch"
        @reached-bottom="loadMore"
        @selected-image="onSelectedImage"
        @like-collateral="onLike"
        @unlike-collateral="onUnlike"
      >
        <template #heading>
          <div
            :style="customStyle"
            class="shared-album-name"
          >
            {{ title }} {{ isTest ? '(Test User)' : '' }}
          </div>
        </template>
      </items-grid>
    </div>
    <!--<pre style="position: absolute;
    background-color: red; font-weight: bolder; color: white;
    font-size: 1em">{{DEBUG}}
      <div>&nbsp;</div></pre>-->

    <items-zoom-modal
      v-model="imageIndex"
      :show="imageIndex >= 0"
      :count="count"
      :next-page-exists="nextPageExists"
      :loading="loading"
      @like-collateral="onLike"
      @unlike-collateral="onUnlike"
    />
  </div>
</template>

<script>
import _ from 'lodash';
import api from '@/_api';
import ItemsGrid from '@/components/Widgets/Collateral/ItemsGrid';
import Listable from '@/components/mixins/listable';

window.zESettings = {
  webWidget: {
    contactForm: {
      suppress: true,
    },
  },
};

export default {
  name: 'LinkedCollateralFolder',
  components: {
    ItemsGrid,
  },
  mixins: [Listable],
  props: {
    mode: {
      type: String,
      default: 'loadMore',
    },
    source: {
      type: String,
      default: 'collateral',
    },
    pageSize: {
      type: Number,
      default: 30,
    },
  },
  data() {
    return {
      ref: 'widget',
      imageIndex: -1,
      // innerWidth: 0,
    };
  },
  computed: {
    title() {
      return (this.search && this.search.length) ? `Search results (${this.elements.length})` : this.folderName;
    },
    folderName() {
      return this.elements && this.elements.length > 0 ? this.elements[0].folder_name : '';
    },
    currentFolder() {
      return this.$store.state.folders.item;
    },
    folderToken() {
      return this.$route.params.token;
    },
    count() {
      return this.$store.state.collateral.count;
    },
    loading() {
      return this.$store.state.collateral.isLoading;
    },
    institutionFontName() {
      return this.$store.state.fonts.fontName;
    },
    customStyle() {
      return { 'font-family': `${this.institutionFontName}, serif` };
    },
    fetchRoute() {
      return 'collateral/shareAlbumPage';
    },
    logoURL() {
      return this.$store.state.institutions.logoURL;
    },
    isTest() {
      return this.$store.state.collateral.is_test;
    },
    // iframeWidth() {
    //   return this.$route.query.w;
    // },
    // iframeZoomCss() {
    //   const factor = !this.iframeWidth || !this.innerWidth ? 1 : this.iframeWidth / this.innerWidth
    //   return {
    //     '--zoom': 3
    //   }
    // },
  },
  beforeMount() {
    if (this.folderToken) {
      this.queryParams.token = this.folderToken;
    }
  },
  // mounted() {
  //   this.$nextTick().then(() => {
  //     this.innerWidth = window.innerWidth;
  //   });
  // },
  methods: {
    onSelectedImage(index) {
      console.log('onSelectedImage', index);
      this.imageIndex = index;
    },
    onSearch: _.debounce(function (evt) {
      this.search = evt;
    }, 200),
    canHover() {
      return (item) => true;
    },
    onLike(itemPk) {
      if (this.isTest) {
        return;
      }
      api.post('/collaterallike/', {
        link: this.$route.params.token,
        collateral: itemPk,
      }).then((response) => {
        this.$store.dispatch('collateral/updateLike', { pk: itemPk, liked: response.data.pk });
      }).catch((error) => {
        if (error.response && error.response.status === 400) {
          console.log('Already liked');
        } else throw (error);
      });
    },
    onUnlike(itemPk, likePk) {
      api.delete(`/collaterallike/${likePk}/`).then((response) => {
        this.$store.dispatch('collateral/updateLike', { pk: itemPk, liked: null });
      });
    },
  },
};
</script>
<style lang="scss">
// $zoom: var(--zoom);

// body, #app {
//   zoom: calc(#{$zoom}*2);
// }
// pre {
//   > div {
//     content: 'ke wea';
//     color:  black;
//     border: 1px solid black;
//     // width: calc(#{$zoom} * 10);
//     width: calc(1cm*#{$zoom});
//     &:after {
//       position: absolute;
//       border: 1px solid blue;
//       width: 1cm;
//       content: "1cm";
//       bottom: 0;
//       left: 0;
//     }
//   }
// }
</style>
<style lang="scss" scoped>
.items-grid-container {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  flex-grow: 1;
  max-height: 100%;
}
.collateral {
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}
.linked-album {
  padding: 10px 0 20px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  display: flex;
  flex-direction: column;
}
::v-deep .basecard {
  border: 1px solid #ECE9E7;
}
.institution_logo {
  margin: 10px 0;
  width: 200px;
  max-height: 70px;
  object-fit: contain;
}
.institution__header{
  display: flex;
  min-height: 100px;
  justify-content: center;
  align-items: center;
}
.shared-album-name {
  font-size: 20px;
}
</style>
